import type { Maybe } from '@amazon/vinyl-util'
import { Entitlement } from '@amzn/vinyl-dmls'
import type { UserTier } from './userContext'

/** The DMLS entitlements an account tier holds; none for a missing or unmodeled tier. */
export function tierEntitlements(tier: Maybe<UserTier>): ReadonlySet<Entitlement> {
    switch (tier) {
        case 'UNLIMITED':
            return new Set([
                Entitlement.KATANA,
                Entitlement.HAWKFIRE,
                Entitlement.SONIC_RUSH,
                Entitlement.ROBIN,
                Entitlement.NIGHTWING,
            ])
        case 'PRIME':
            return new Set([Entitlement.ROBIN, Entitlement.SONIC_RUSH, Entitlement.NIGHTWING])
        case 'FREE':
            return new Set([Entitlement.NIGHTWING])
        default:
            return new Set()
    }
}
